export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="text-3xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Selem&Selem
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Investimentos e consultoria estratégica especializada na alocação de recursos na economia real.
            </p>
            <div className="flex space-x-3">
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-white"></i>
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('about');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-slate-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('values');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-slate-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Valores
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('team');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-slate-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Equipe
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('portfolio');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-slate-400 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Portfólio
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-teal-400 mt-1"></i>
                <div>
                  <a href="tel:+551141911617" className="text-slate-400 hover:text-teal-400 transition-colors cursor-pointer block text-sm">
                    (11) 4191-1617
                  </a>
                  <a href="tel:+5511963720003" className="text-slate-400 hover:text-teal-400 transition-colors cursor-pointer block text-sm">
                    (11) 96372-0003
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span className="text-slate-400 text-sm">
                  Al. Brasil, 584<br />
                  Alphaville – Barueri - SP
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} SELEM Participações. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
